import React, { useEffect, useState } from 'react';


const API_URL = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

export default function MailingMatrixServiceSelector({ caseId, value, onChange }) {
  const [latest, setLatest] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    async function load() {
      setLoading(true);
      setError('');
      try {
        const token = localStorage.getItem('accessToken');
        const response = await fetch(
          `${API_URL}/case/${caseId}/creditor-mailing-matrices/`,
          { headers: token ? { Authorization: `Bearer ${token}` } : {} },
        );
        const payload = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(payload.detail || 'Could not load the creditor mailing matrix.');
        if (!cancelled) setLatest(payload.latest || null);
      } catch (loadError) {
        if (!cancelled) setError(loadError.message || 'Could not load the creditor mailing matrix.');
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    load();
    return () => { cancelled = true; };
  }, [caseId]);

  const enabled = Boolean(value?.enabled);

  const setEnabled = checked => {
    if (!checked) {
      onChange(null);
      return;
    }
    if (!latest) return;
    onChange({
      enabled: true,
      matrix_id: latest.id,
      method: value?.method || 'USM',
      recipients: latest.recipients || [],
      recipient_count: latest.recipient_count,
      retrieved_at: latest.retrieved_at,
      pdf_url: latest.pdf_url,
    });
  };

  const setMethod = method => {
    if (!latest) return;
    onChange({
      ...(value || {}),
      enabled: true,
      matrix_id: latest.id,
      method,
      recipients: latest.recipients || [],
      recipient_count: latest.recipient_count,
      retrieved_at: latest.retrieved_at,
      pdf_url: latest.pdf_url,
    });
  };

  return (
    <div className="mb-4 rounded-md border border-indigo-200 bg-indigo-50 p-3">
      <div className="font-semibold text-indigo-950">Serve the court mailing matrix</div>
      {loading ? (
        <p className="mt-1 text-sm text-indigo-800">Loading the latest saved matrix…</p>
      ) : error ? (
        <p className="mt-1 text-sm font-medium text-red-700">{error}</p>
      ) : !latest ? (
        <p className="mt-1 text-sm text-amber-900">
          No court mailing matrix is saved. Pull the current matrix from the case home page first.
        </p>
      ) : (
        <>
          <label className="mt-2 flex items-start gap-2 text-sm text-indigo-950">
            <input type="checkbox" checked={enabled} onChange={event => setEnabled(event.target.checked)} className="mt-1" />
            <span>
              Mail to all {latest.recipient_count} creditors on the matrix retrieved {new Date(latest.retrieved_at).toLocaleString()}.
              The court matrix will be attached and envelopes will be created for every address.
              You can still select individual creditors for a different service method below.
            </span>
          </label>
          {enabled && (
            <label className="mt-3 block text-sm font-medium text-indigo-950">
              Service method for the mailing list
              <select value={value?.method || 'USM'} onChange={event => setMethod(event.target.value)} className="mt-1 block w-full rounded border border-indigo-300 bg-white px-2 py-2">
                <option value="USM">United States first class mail</option>
                <option value="Certified">Certified mail</option>
              </select>
            </label>
          )}
        </>
      )}
    </div>
  );
}
